<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="
        chk_relation_type_editable('/master/list') ? fromParentBtn : ''
      "
      :btnClass="'btn-primary'"
      :btnToLink="'/event_cd/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <div
      class="w100"
      v-if="
        typeof event_cd_list === 'object' &&
        Object.keys(event_cd_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 10%">コード</th>
            <th style="width: 20%">名称</th>
            <th style="width: 10%">略称</th>
            <th style="width: auto">
              競技会のクラス作成で選択可能なライセンス
            </th>
            <th style="width: 7%">ソートNo.</th>
            <th colspan="2" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in event_cd_list" :key="list.id">
            <td>{{ list.event_cd }}</td>
            <td>{{ list.label }}</td>
            <td>{{ list.short_label }}</td>
            <td>
              <span
                class="badge bg-secondary me-2 mb-2"
                v-for="rel in list.relation"
                :key="rel"
              >
                {{ (get_license_data(rel.license_cd) || {}).short_label }}
              </span>
            </td>
            <td>{{ list.sort }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                v-if="chk_relation_type_editable('/master/list')"
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'EventCdListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '競技会用種目マスタ一覧',
      fromParentBtn: 'データ登録',
      event_cd_obj: [],
      license_cd_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert
  },
  computed: {
    ...mapState({}),
    get_license_data: function () {
      const lists = this.license_cd_list
      return function (license_cd) {
        if (
          typeof lists === 'object' &&
          lists.find(list => list.id == license_cd)
        ) {
          return lists.find(list => list.id == license_cd)
        }
        return false
      }
    },
    license_cd_list: function () {
      const lists = [...this.license_cd_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    event_cd_list: function () {
      const lists = [...this.event_cd_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadEventCdList()
    await this.loadLicenseCdList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '競技会用種目マスタです。'
  },

  methods: {
    delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.event_cd_obj.find(event => {
          return event.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'event_cd' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(() => {
            this.loadEventCdList()
          })
      }
    },
    async loadEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
        .then(async response => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/event_cd/' + target + '/' })
    }
  }
}
</script>
